import { FC, MouseEventHandler, ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import { handleBreakpoints } from '@mui/system';

interface BreakpointedMaxWidth {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
}

export interface AppBarInternalUserProps {
  children?: ReactNode;
  maxWidth?: BreakpointedMaxWidth;
  onClick?: MouseEventHandler;
}

interface AppBarInternalUserRootProps {
  ownerState: {
    shouldClipText?: boolean;
    maxWidth?: BreakpointedMaxWidth;
  };
}

const AppBarInternalUserRoot = styled('div', {
  name: 'O2AppBarInternal',
  slot: 'User',
  shouldForwardProp: (prop) => prop !== 'ownerState',
})<AppBarInternalUserRootProps>(({ theme, ownerState }) => ({
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
  '&:hover': {
    cursor: 'pointer',
  },
  ...(ownerState.shouldClipText && {
    textOverflow: 'ellipsis',
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    verticalAlign: 'middle',
    ...handleBreakpoints({ theme }, ownerState.maxWidth, (propValue) => ({
      maxWidth: propValue || 'none',
    })),
  }),
}));

const AppBarInternalUser: FC<AppBarInternalUserProps> = (props) => {
  const { maxWidth, ...other } = props;

  const ownerState = {
    shouldClipText: maxWidth && Object.values(maxWidth).reduce((i, r) => i + r, 0) > 0,
    maxWidth,
  };

  return <AppBarInternalUserRoot ownerState={ownerState} {...other} />;
};

export default AppBarInternalUser;
